module.exports = __webpack_public_path__ + "static/img/icon-search-pink.0c4a4eb7.png";